/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Tax controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetTaxByIdResponse, UpdateTaxRequest, GetTaxSelectResponse, GetTaxesResponse, CreateTaxRequest, CreateTaxResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TaxService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTaxById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTaxByIdResponse>;
    getTaxById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTaxByIdResponse>>;
    getTaxById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTaxByIdResponse>>;
    getTaxById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTax(id: number, updateTaxRequest: UpdateTaxRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTax(id: number, updateTaxRequest: UpdateTaxRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTax(id: number, updateTaxRequest: UpdateTaxRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTax(id: number, updateTaxRequest: UpdateTaxRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTaxRequest, requestOptions);
    }

    deleteTax(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTax(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTax(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTax(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getTaxSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTaxSelectResponse>;
    getTaxSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTaxSelectResponse>>;
    getTaxSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTaxSelectResponse>>;
    getTaxSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getTaxes(searchTerm?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTaxesResponse>;
    getTaxes(searchTerm?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTaxesResponse>>;
    getTaxes(searchTerm?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTaxesResponse>>;
    getTaxes(searchTerm?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTax(createTaxRequest: CreateTaxRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTaxResponse>;
    createTax(createTaxRequest: CreateTaxRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTaxResponse>>;
    createTax(createTaxRequest: CreateTaxRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTaxResponse>>;
    createTax(createTaxRequest: CreateTaxRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Taxe`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTaxRequest, requestOptions);
    }
}
